import { Typography } from "@material-tailwind/react";

interface FeatureProps {
  Icon: () => JSX.Element;
  title: string;
  text: string;
}

function FeatureComponent(props: { feature: FeatureProps }) {
  return (
    <>
      <div className={`h-full w-[317px] sm:w-[330px] 2xl:w-[291px] flex flex-col bg-[#FFFFFF] border-[#FF7C46] border-t-8 rounded-tl-[20px] rounded-br-[20px] px-2 py-5 mx-auto`}>
        <div className="flex 2xl:flex-col items-center pl-[20px] 2xl:pl-[0px]">
          <div className="bg-#F6F6F6 rounded-[18px] w-[59px] h-[53px] 2xl:w-[65px] 2xl:h-[59px] flex flex-shrink-0 items-center justify-center shadow-circle">
            <props.feature.Icon />
          </div>
          <Typography variant="h3" className="h-fit text-#2C2C2C 2xl:px-[20px] text-base 2xl:text-lg font-semibold tracking-[0.8px] w-full text-left 2xl:text-center pl-[10px] 2xl:mt-[15px]">
            {props.feature.title}
          </Typography>
        </div>
        <Typography variant="h4" className="mx-[10px] mt-[20px] 2xl:ml-[30px] text-#2C2C2C text-sm 2xl:text-base font-light tracking-[0.7px] text-left">
          {props.feature.text}
        </Typography>
      </div>
    </>
  );
}

export default FeatureComponent;
